import { CavityWallLayers } from "@iko-design-center/shared";
import { MultiSelectOption } from "../../components/common/MultiSelect";

export type DownloadState = {
  technicalFiche: {
    wallType: boolean;
    wallInsulation: boolean;
    outerCavityLeaf: boolean;
  };
  DOP: {
    wallType: boolean;
    wallInsulation: boolean;
    outerCavityLeaf: boolean;
  };
  thermalCalculation: boolean;
  specifications: boolean;
  BIMFile: boolean;
  screenshots: boolean;
  processingGuideline: boolean;
};

export const initialDownloadState: DownloadState = {
  technicalFiche: {
    wallType: false,
    wallInsulation: false,
    outerCavityLeaf: false,
  },
  DOP: {
    wallType: false,
    wallInsulation: false,
    outerCavityLeaf: false,
  },
  thermalCalculation: false,
  specifications: false,
  BIMFile: false,
  screenshots: false,
  processingGuideline: false,
};

export const allSelectedDownloadState: DownloadState = {
  technicalFiche: {
    wallType: true,
    wallInsulation: true,
    outerCavityLeaf: true,
  },
  DOP: {
    wallType: true,
    wallInsulation: true,
    outerCavityLeaf: true,
  },
  thermalCalculation: true,
  specifications: true,
  BIMFile: true,
  screenshots: true,
  processingGuideline: true,
};

export type LayerState = {
  [key in CavityWallLayers]: boolean;
};

export function getLayerOptions({
  t,
  state,
}: {
  t: any;
  state: LayerState;
}): MultiSelectOption<CavityWallLayers>[] {
  return [
    {
      label: t("modal.download.insulation"),
      value: CavityWallLayers.wallInsulation,
      checked: state.wallInsulation,
    },
  ];
}
